import axios from "axios";
import router from '../../router/index';

export const state = {
    cart: [],
    products: "",
    total_cart: "",
    save_status: false,
    sale_save_status: false,
    quotations: [],
    quotation: [],

};
export const getters = {
    TotalCart: state => state.total_cart,
    QuotationCart: state => state.cart.data,
    SaveStatus: state => state.save_status,
    Quotations: state => state.quotations.data,
    Quotation: state => state.quotation.data,

};
export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_CART(state, newValue) {
        state.cart = newValue
    },

    SET_TOTAL_CART(state, newValue) {
        state.total_cart = newValue
    },
    SET_QUOTATIONS(state, newValue) {
        state.quotations = newValue
    },
    SET_QUOTATION(state, newValue) {
        state.quotation = newValue
    },


};
export const actions = {

    // add products to quotation cart
    addToCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('quotation_cart', data).then(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // edit Quotation cart
    editCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`quotation_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete items from Quotation cart
    deleteCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`quotation_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process Quotation
    saveQuotation({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`quotations`, data).then(response => {
            commit('SET_SAVE_STATUS', false)

            if (response.status == 200) {
                let message = { 'msg': "Quotation Recorded successfully" }
                dispatch('notification/success', message, { root: true })
                dispatch('fetchCart')
                dispatch('fetchTotCart')
            } else if (response.status == 201) {
                let message = response.data.message;
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to record a Quotation" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete Quotation
    deleteQuotation({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`quotations/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchQuotations')
            if (response.status == 200) {
                let message = { 'msg': "Quotation Deleted successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = response.data.message;
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' Deleting Failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    
    // get Quotation cart
    fetchCart({ commit }) {
        axios.get('quotation_cart').then(cart => {
            commit('SET_CART', cart.data)
        })
    },
    // 

    // get Quotation cart Total
    fetchTotCart({ commit }) {
        axios.get('total_quotation_cart').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },
    // get Quotation
    fetchQuotations({ commit }) {
        axios.get('quotations').then(cart => {
            commit('SET_QUOTATIONS', cart.data)
        })
    },
    // get a single Quotation
    fetchQuotation({ commit }, id) {
        axios.get(`quotations/${id}`).then(cart => {
            commit('SET_QUOTATION', cart.data)
        })
    },

    // Dispatch Quotation
    dispatchQuotation({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`dispatch_quotation`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            if (response.status == 200) {
                commit('SET_SAVE_STATUS', false)
                router.push('/sales/order').catch(() => {});              
            } else if (response.status == 201) {
                commit('SET_SAVE_STATUS', false)
                let message = { 'msg': response.data.message };
                dispatch('notification/error', message, { root: true })
            }
            dispatch('fetchQuotations')
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to dispatch Quotation Items" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add products to quotation
    addQuotationItem({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('add_quotationitem', data).then(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchQuotation', data.quotation_id)
            let message = { 'msg': "Quotation product added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // edit Quotation
    editQuotationItem({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`edit_quotationitem/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchQuotation', data.quotation_id)
            if (response.status == 200) {
                let message = { 'msg': "Quotation product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit quotation Item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete items from Quotation
    deleteQuotationItem({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`delete_quotationitem/${data.id}`).then(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchQuotation', data.quotation_id)
            let message = { 'msg': "Product deleted from Quotation successfully" }
            dispatch('notification/success', message, { root: true })            
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': 'Error in deleting quotation item, please try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
};